import { TAGSvgIcon } from '@aspendental/shared-components-web';
import { Box, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';
import { list } from './LoginWithEmailModalBody.styles';
type LoginWithEmailBodyProps = {
  toggleDialog?: () => void;
};
const LoginWithEmailBody: FC<LoginWithEmailBodyProps> = ({
  toggleDialog
}) => {
  return <>
			{toggleDialog && <TAGSvgIcon dataTestId="close-icon" onClick={toggleDialog} style={{
      position: 'absolute',
      right: 18,
      top: 24
    }} icon="CloseFunc" />}
			<Box data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
				<Typography align="center" color="text.primary" variant="header1" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
					Try these tips if you didn&apos;t receive a link
				</Typography>
				<List sx={list.listWrapper} data-sentry-element="List" data-sentry-source-file="LoginWithEmailModalBody.tsx">
					<ListItem sx={list.item.wrapper} data-sentry-element="ListItem" data-sentry-source-file="LoginWithEmailModalBody.tsx">
						<Box sx={list.item.title} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="floatingLabel" color="text.light" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								1
							</Typography>
						</Box>
						<Box sx={list.item.textWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="header3" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">Confirm you’re using the correct email.</Typography>
							<Typography variant="bodySmallBook" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								Double-check you are using the correct email and it is the email associated with your
								account.
							</Typography>
						</Box>
					</ListItem>
					<ListItem sx={list.item.wrapper} data-sentry-element="ListItem" data-sentry-source-file="LoginWithEmailModalBody.tsx">
						<Box sx={list.item.title} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="floatingLabel" color="text.light" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								2
							</Typography>
						</Box>
						<Box sx={list.item.textWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="header3" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">Check Spam/Junk folder.</Typography>
							<Typography variant="bodySmallBook" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								Check your spam or junk email folder in case the verification email was mistakenly
								categorized as spam.
							</Typography>
						</Box>
					</ListItem>
					<ListItem sx={list.item.wrapper} data-sentry-element="ListItem" data-sentry-source-file="LoginWithEmailModalBody.tsx">
						<Box sx={list.item.title} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="floatingLabel" color="text.light" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								3
							</Typography>
						</Box>
						<Box sx={list.item.textWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailModalBody.tsx">
							<Typography variant="header3" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">Call your local office</Typography>
							<Typography variant="bodySmallBook" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailModalBody.tsx">
								Still having trouble? We recommend you call your local office for assistance.
							</Typography>
						</Box>
					</ListItem>
				</List>
			</Box>
		</>;
};
export default LoginWithEmailBody;